import { ExternalLink } from "lucide-react";
import Ncte from '../assets/ncte.png'
export default function SiddharthPTCCollege() {
  const profile = [
    { label: "Programme", value: "D.El.Ed." },
    { label: "Duration", value: "2 Years" },
    { label: "Intake", value: "100 Seats" },
    { label: "Recognition", value: "NCTE" },
    { label: "Affiliation", value: "SCERT" },
  ];

  return (
    <div className="bg-slate-50 min-h-screen">
      {/* Hero */}
      {/* Hero */}
      <section className="px-6 pt-28 pb-20">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-[32px] bg-gradient-to-r from-blue-700 to-indigo-700 p-10 text-white">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
              {/* Left */}
              <div>
                <h1 className="mt-4 text-5xl font-bold">
                  Siddharth PTC College
                </h1>

                <p className="mt-3 text-blue-100">
                  Mansa • Gandhinagar • Gujarat
                </p>
              </div>

              {/* Right */}
              <a
                href="https://web.ncte.gov.in"
                target="_blank"
                rel="noreferrer"
                className="
            flex
            items-center
            gap-4
            bg-white/10
            hover:bg-white/20
            transition
            rounded-2xl
            px-6
            py-5
            backdrop-blur
          "
              >
                <img
                  src={Ncte}
                  alt="NCTE"
                  className="h-16 w-16 object-contain bg-white rounded-xl p-2"
                />

                <div>
                  <p className="text-sm text-blue-100">Official Website</p>

                  <div className="flex items-center gap-2 font-medium">
                    Visit NCTE
                    <ExternalLink size={18} />
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <main className="max-w-6xl mx-auto px-6 pb-20 space-y-10">
        {/* Profile */}
        <Section title="Institution Profile">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
            {profile.map((item) => (
              <div
                key={item.label}
                className="
                  bg-white
                  rounded-2xl
                  p-6
                  border
                  hover:-translate-y-1
                  hover:shadow-lg
                  transition
                "
              >
                <p className="text-slate-500 text-sm">{item.label}</p>

                <h3 className="mt-3 font-semibold text-slate-800">
                  {item.value}
                </h3>
              </div>
            ))}
          </div>
        </Section>

        {/* Infrastructure */}
        <Section title="Academic Infrastructure">
          <div className="grid md:grid-cols-2 gap-5">
            <InfoCard
              title="Academic Facilities"
              content="Spacious classrooms, library, computer laboratory, psychology laboratory."
            />

            <InfoCard
              title="Learning Resources"
              content="Science laboratory, educational technology laboratory, language resource centre and multipurpose hall."
            />
          </div>
        </Section>

        {/* Library + ICT */}
        <div className="grid lg:grid-cols-2 gap-8">
          <Section title="Library Facilities">
            <p className="text-slate-600 leading-8">
              Educational books, journals, reference materials, curriculum
              resources, children's literature and teaching-learning resources.
            </p>
          </Section>

          <Section title="ICT & Technology">
            <ul className="space-y-3 text-slate-600">
              <li>✓ Computer Systems</li>
              <li>✓ Internet Connectivity</li>
              <li>✓ LCD Projectors</li>
              <li>✓ Digital Learning Resources</li>
            </ul>
          </Section>
        </div>

        {/* Developments */}
        <Section title="Recent Developments">
          <div className="rounded-2xl bg-blue-50 p-8">
            <p className="text-slate-700 leading-8">
              Infrastructure, laboratories, library resources and digital
              facilities are upgraded regularly to improve academic quality and
              student support.
            </p>
          </div>
        </Section>

        {/* Contact */}
        <Section title="Contact Information">
          <div className="bg-white rounded-2xl border p-8">
            <h3 className="text-xl font-semibold">Siddharth PTC College</h3>

            <div className="mt-5 space-y-3 text-slate-600">
              <p>Post-Mansa, Ta-Mansa, Dist-Gandhinagar, Gujarat</p>

              <p>siddharthptccollege@gmail.com</p>

              <p>9327031378 • 8160498340</p>
            </div>
          </div>
        </Section>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-3xl font-bold text-slate-800 mb-6">{title}</h2>

      {children}
    </section>
  );
}

function InfoCard({ title, content }) {
  return (
    <div className="bg-white border rounded-2xl p-8 shadow-sm">
      <h3 className="font-semibold text-lg mb-3">{title}</h3>

      <p className="text-slate-600 leading-8">{content}</p>
    </div>
  );
}
